import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// COMPONENTS
import CartItemActionButtons from '../CartItemActionButtons/CartItemActionButtons';

// DS
import { Col, Image, VertTypography } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Cart/CartItemDetailsStyles.less';

// UTILS
import { limitString } from 'Utils/commons/string';
import ynToBool from 'Utils/ynToBool';
import { get } from 'lodash';

// CART ITEM DETAILS COMPONENT
const CartItemDetails = ({
  imageAlt,
  imageUrl,
  itemName,
  isFavorited,
  hideActionsButtons,
  sku,
  isUnavailable,
  voucher,
  skuUnavailable
}) => {
  /* Hooks */
  const navigate = useNavigate();
  const itemsCartReducer = useSelector(({ Cart: data }) => data);
  const ShippingCart = useSelector(({ Shipping: data }) => data);

  const hasVoucher = get(voucher, 'hasVoucher', false);
  const typeVoucher = get(voucher, 'typeVoucher', '');

  /* Vars */
  const isLoading =
    ynToBool(itemsCartReducer?.isLoading) || ynToBool(ShippingCart?.isLoading);
  const imageClassName = skuUnavailable || isUnavailable
    ? 'image-unavailable-product'
    : 'item-image';

  /* Handlers */
  const goToProductPageDetailsHandler = (skuId) => {
    if (skuId) {
      navigate(`/product/${skuId}`);
    }
  };

  /* Renders */
  return (
    <Col className="cart-item-details padding-x-extra-small">
      <Image
        alt={imageAlt}
        className={imageClassName}
        onClick={() => goToProductPageDetailsHandler(sku)}
        preview={false}
        src={imageUrl}
      />

      <Col className="item-info">
        {isUnavailable && (
          <VertTypography.Paragraph className="unavailable-badge">
            Indisponível
          </VertTypography.Paragraph>
        )}

        <VertTypography.Paragraph
          className="item-name"
          onClick={() => goToProductPageDetailsHandler(sku)}
          role="link"
        >
          {`
            ${limitString(itemName, 50)}  ${
            hasVoucher ? `- ${typeVoucher}` : ''
          }
            `}
        </VertTypography.Paragraph>

        {!hideActionsButtons && (
          <CartItemActionButtons
            isLoading={isLoading}
            sku={sku}
            isFavorited={isFavorited}
          />
        )}
      </Col>
    </Col>
  );
};

CartItemDetails.propTypes = {
  hideActionsButtons: PropTypes.bool,
  imageAlt: PropTypes.string,
  imageUrl: PropTypes.string,
  isFavorited: PropTypes.bool,
  itemName: PropTypes.string,
  itemSeller: PropTypes.string,
  shippingValue: PropTypes.number,
  sku: PropTypes.string,
  isUnavailable: PropTypes.bool,
};

export default CartItemDetails;
